import * as Yup from "yup";

export const exercisesStepSchema = Yup.object({
  exercises: Yup.array()
    .of(
      Yup.object({
        id: Yup.string().required("ID ćwiczenia jest wymagane"),
        title: Yup.string(),
        description: Yup.string(),
        url: Yup.string(),
      })
    )
    .default([])
});

